import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {ToastService} from '../toast-service';
import {CrystalclearArchiveBackUrl} from "../config/crystalclear-archive-back-url";
import {ProfileAbsService} from "./profile-abs.service";
import {Observable} from "rxjs";
import {ApiValidation} from "../../model/api/api-validation";
import {ReportTask} from "../../model/archive/report-task";
import {FieldRequest} from "../../model/api/field-request";
import {ProfileFieldResult} from "../../model/archive/profile-field-result";
import {ReportProfile} from "../../model/archive/report-profile";
import {InvoiceDownloadRequest} from "../../model/billing/invoice-download-request";

@Injectable({
  providedIn: 'root'
})
export class InvoiceProfileService extends ProfileAbsService {

  constructor(http: HttpClient,
              toastService: ToastService) {
    super(http,
      toastService,
      CrystalclearArchiveBackUrl.GET_ARCHIVE_INVOICE_PROFILE_LIST,
      CrystalclearArchiveBackUrl.SAVE_ARCHIVE_INVOICE_PROFILE,
      CrystalclearArchiveBackUrl.DELETE_ARCHIVE_INVOICE_PROFILE,
      CrystalclearArchiveBackUrl.DOWNLOAD_ARCHIVE_INVOICE_PROFILE_ASYNC,
      CrystalclearArchiveBackUrl.DOWNLOAD_FORPROFILE_ARCHIVE_INVOICE_PROFILE_ASYNC,
      CrystalclearArchiveBackUrl.EXECUTE_ARCHIVE_INVOICE_PROFILE_ASYNC,
      CrystalclearArchiveBackUrl.GET_ARCHIVE_INVOICE_PROFILE_EXPORT_TEMPLATES_FORM,
      CrystalclearArchiveBackUrl.GET_ARCHIVE_INVOICE_PROFILE_EXPORT_TEMPLATES_PROFILE,
      CrystalclearArchiveBackUrl.GET_ARCHIVE_INVOICE_PROFILE_PROFILES_FIELDS_FORM,
      CrystalclearArchiveBackUrl.GET_ARCHIVE_INVOICE_PROFILE_MAIL_TEMPLATES,
      CrystalclearArchiveBackUrl.GET_ARCHIVE_INVOICE_PROFILE_FILE_LOCATIONS,
      CrystalclearArchiveBackUrl.GET_ARCHIVE_INVOICE_BATCH_UPDATE);
  }
  public downloadInvoice(request : InvoiceDownloadRequest): Observable<ApiValidation<string>> {
    return this.post(CrystalclearArchiveBackUrl.ARCHIVE_INVOICE_DOWNLOAD_ASYNC, request);
  }
  public emailInvoice(request : InvoiceDownloadRequest): Observable<ApiValidation<string>> {
    return this.post(CrystalclearArchiveBackUrl.ARCHIVE_INVOICE_EMAIL_ASYNC, request);
  }
}
